import usePageTitle from "@/hooks/use-page-title";

export default function Privacy() {
  usePageTitle("Privacy Policy");
  return (
    <div className="max-w-4xl mx-auto px-4 lg:px-8 py-16">
      <div className="overline mb-2">Legal</div>
      <h1 className="font-display text-5xl md:text-6xl font-black tracking-tighter mb-8">Privacy Policy</h1>
      <div className="prose prose-zinc max-w-none space-y-6 text-zinc-700 text-sm leading-relaxed">
        <p><strong>Last updated:</strong> {new Date().toLocaleDateString("en-IN", { year: "numeric", month: "long", day: "numeric" })}</p>

        <div>
          <h2 className="font-display text-2xl font-black mt-8 mb-3">1. Who We Are</h2>
          <p>Brothers Advertising (a unit of J U ENTERPRISES), located at Shop No. 02, Payal Residency, Plot No. 29, Sector 16, Taloja Phase 2, Navi Mumbai – 410208, is committed to protecting the privacy of our customers and website visitors.</p>
        </div>

        <div>
          <h2 className="font-display text-2xl font-black mt-8 mb-3">2. Information We Collect</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li><strong>Contact details</strong> — name, phone, email, company, GSTIN, shipping address</li>
            <li><strong>Order &amp; artwork files</strong> — files you upload for print jobs, only accessible to you and our staff</li>
            <li><strong>Communications</strong> — messages sent via our contact form, WhatsApp, phone or email</li>
            <li><strong>Payment information</strong> — payment mode &amp; reference (we do NOT store card / UPI credentials)</li>
          </ul>
        </div>

        <div>
          <h2 className="font-display text-2xl font-black mt-8 mb-3">3. How We Use It</h2>
          <p>Your data is used strictly to process orders, deliver goods, invoice you, and provide customer service. We do not sell, rent or share your personal data with any third party for marketing purposes.</p>
        </div>

        <div>
          <h2 className="font-display text-2xl font-black mt-8 mb-3">4. File Retention</h2>
          <p>Printable design files uploaded through the customer portal are automatically deleted 15 days after upload. Invoice records are retained for statutory periods as required by Indian tax law.</p>
        </div>

        <div>
          <h2 className="font-display text-2xl font-black mt-8 mb-3">5. Cookies &amp; Tracking</h2>
          <p>We use a minimal number of cookies solely to remember your login session on our order-management portal. We do not run advertising or cross-site tracking cookies.</p>
        </div>

        <div>
          <h2 className="font-display text-2xl font-black mt-8 mb-3">6. Your Rights</h2>
          <p>You may request access, correction or deletion of your personal data at any time by writing to <a href="mailto:print@brothersdigital.in" className="text-[#FF6B00] font-semibold">print@brothersdigital.in</a>, calling our Customer Care on <a href="tel:02247427059" className="text-[#FF6B00] font-semibold">022 4742 7059</a>, or on our mobile line +91 80709 70980.</p>
        </div>

        <div>
          <h2 className="font-display text-2xl font-black mt-8 mb-3">7. Contact</h2>
          <p>For any privacy-related concern, contact us at: <br />
          Brothers Advertising (a unit of J U ENTERPRISES) <br />
          Shop No. 02, Payal Residency, Plot No. 29, Sector 16, Taloja Phase 2, Navi Mumbai – 410208 <br />
          Customer Care: 022 4742 7059 · Mobile: +91 80709 70980 · Email: print@brothersdigital.in</p>
        </div>
      </div>
    </div>
  );
}
